module.exports = "../content/cabdb4a12e5de710afde298809306937.ttf";